<app-modal-shell
  [title]="'NAME_DATA.TITLE'"
  [cancelLabel]="'NAME_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'NAME_DATA.BUTTONS.OK'"
  [saveDisabled]="saveDisabled"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <div class="form-group">
    <app-name-details-form [initialData]="nameDetails" testIdPrefix="name-data-"></app-name-details-form>
  </div>

</app-modal-shell>
